import { useEffect, useState } from 'react';

// Light/dark theme. Follows the system setting until the user picks one,
// then remembers it. public/index.html applies the saved theme before React
// loads so the page never flashes the wrong colours.
const KEY = 'skrl-theme';
const media = () => window.matchMedia('(prefers-color-scheme: light)');

function saved() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function useTheme() {
  const [theme, setTheme] = useState(() => saved() || (media().matches ? 'light' : 'dark'));

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  // Track the system setting while the user hasn't chosen.
  useEffect(() => {
    const m = media();
    const onChange = e => { if (!saved()) setTheme(e.matches ? 'light' : 'dark'); };
    m.addEventListener('change', onChange);
    return () => m.removeEventListener('change', onChange);
  }, []);

  // Explicit choice ('light' | 'dark'): applied and remembered.
  const choose = (next) => setTheme(t => {
    const value = typeof next === 'function' ? next(t) : next;
    try { localStorage.setItem(KEY, value); } catch {}
    return value;
  });

  return [theme, choose];
}

// Make a data-driven colour (badge, page type, brand) readable as text in
// both themes: unchanged in dark mode, blended toward the text colour in light
// mode so pastels like lime stay legible on white. See --tone in index.css.
export const tone = (color) => `color-mix(in oklab, ${color} var(--tone), var(--fg))`;
